
import { Progress } from 'vant'
import wx from 'weixin-js-sdk'
import { getConfig } from '@/api/wx.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import Storage from '@/storage'
import config from '@/config'
import { getListsdetail, getListsread, getListszan, postZan } from '@/api/youzheng'
import { addPartyCount } from '@/api/jfhl.js'
import { operateCreditlist, checkCredit } from '@/api/user'
import icovote1 from '@/assets/icon_dianzan.png'
import icovote2 from '@/assets/icon_dianzan2.png'
import { funcUrlDel } from '@/libs/utils'
export default {
name: 'yzDetail',
components: {
Swiper,
SwiperItem,
[Progress.name]: Progress
},
data () {
return {
baseUrl: config.baseUrl,
obj: {},
id: this.$route.params.type,
icovote1: icovote1,
icovote2: icovote2,

like: {
count: 0,
islike: 1
},
piclist: [],
imglist: [],
videoList: [],
sourcetype: 1,
readnum: '',
owner_type: config.owner_type,
time: 15000,
nowtime: 0,
timer: 0,
showtiming: false
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.wxconfig()

this.getContent()
this.getRead()

if (this.accountid) { // 非企业用户只能查看页面
this.addcount()

this.getlike()
this.check()
}
},
mounted () {
},
destroyed () {
clearInterval(this.timer)
},
watch: {
nowtime: function (newVal, oldVal) {
let _this = this
if (newVal >= 15000) {
clearInterval(this.timer)
let close = setTimeout(function () {
_this.showtiming = false
}, 2000)
this.addCredit()
console.log('down')
}
}
},
methods: {
check () {
let _this = this
checkCredit({
accountid: this.accountid,
rulecode: 'rule_006',
owner_type: this.owner_type,
relationtype: 1,
relationid: this.id,
terminaltype: 2
}).then(res => {
if (res.returnValue.ischeck != 'false') {
_this.showtiming = true
this.timer = setInterval(this.countDown, 100)
} else {
console.log('no')
_this.showtiming = false
}
})
},
countDown () {
this.nowtime += 100
},
getContent () {
getListsdetail({
ID: this.id
}).then(res => {
this.obj = res.obj
document.title = res.obj.TITLE
res.obj.mobilePicsList.forEach(item => {
this.imglist.push(this.baseUrl + item.FILEPATH)
this.piclist = this.imglist.map((one, index) => ({
url: 'javascript:',
img: one
}))
})
this.videoList = res.obj.showvideosList
this.share() 
})
},

getlike () {
getListszan({
contentid: this.id,
openid: this.accountid,
sourcetype: this.sourcetype
}).then(res => {
this.like = res.obj
})
},

add (islike) {
if (this.accountid == '' || this.accountid == null) {
return false
}
postZan({
openid: this.accountid,
contentid: this.id,
iscancle: islike,
sourcetype: this.sourcetype
}).then(res => {
if (islike === 1) {
this.$vux.toast.text('点赞+1', 'middle')
operateCreditlist({
accountid: this.accountid,
rulecode: 'wzdz001',
owner_type: this.owner_type,
relationtype: 1,
relationid: this.id,
terminaltype: 2
}).then(res => { })
} else {
this.$vux.toast.text('您已经取消点赞', 'middle')
}
this.getlike()
})
},

getRead () {
getListsread({
id: this.id
}).then(res => {
this.readnum = res.obj
})
},
addCredit () {
/* 添加积分 */
if (this.accountid !== '' && this.accountid != null) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'rule_006',
owner_type: this.owner_type,
relationtype: 1,
relationid: this.id,
terminaltype: 2
}).then(res => { })
}
},
addcount () {
addPartyCount({
accoutid: this.accountid,
credittype: 3
}).then(res => {
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'previewImage'] 
})
})
},

preview (index, fileList) {
let arr = fileList.map(item => item.img)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
share () {
let link = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + funcUrlDel('code') + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
wx.ready(() => { // 需在用户可能点击分享按钮前就先调用

wx.onMenuShareAppMessage({
title: this.obj.TITLE, // 分享标题
desc: '', // 分享描述
link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: this.baseUrl + this.obj.mobileTitleImgURL, // 分享图标
type: 'link',
dataUrl: '',
success: function () {

}
})

wx.onMenuShareTimeline({
title: this.obj.TITLE, // 分享标题
link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: this.baseUrl + this.obj.mobileTitleImgURL, // 分享图标
success: function () {

}
})
})
}
}
}
